import * as React from 'react';
import ParameterLayout from "./parameterLayout";
const NumberParameter = (props) => {

    return (
        <ParameterLayout parameter={props.parameter} type={props.type} description={props.description} required={props.required} disable={props.disable}>
            <div className="value-inner--select">
                <input type="number"
                       step="1"
                       value={props.value}
                       className="d-flex"
                       onChange={(e)=>props.onChange(e)}
                       placeholder={props.placeholder}/>
            </div>
        </ParameterLayout>
    )
}

export default NumberParameter;